var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icomoon-ignore"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M315.080 117.846v39.692h-236.308v78.769h78.769v669.54c0 64.922 53.23 118.153 118.154 118.153h472.615c64.923 0 118.154-53.231 118.154-118.153v-669.54h78.765v-78.769h-236.303v-39.692c0-64.615-53.231-117.846-117.846-117.846h-158.154c-64.615 0-117.846 53.231-117.846 117.846zM591.080 78.769c22.153 0 39.077 16.923 39.077 39.077v39.692h-236.308v-39.692c0-22.154 16.923-39.077 39.077-39.077h158.154zM236.31 236.308h551.385v669.54c0 22.153-17.231 39.381-39.385 39.381h-472.615c-22.153 0-39.385-17.229-39.385-39.381v-669.54zM315.080 866.458h78.769v-551.38h-78.769v551.38zM472.618 315.077h78.769v551.38h-78.769v-551.38zM630.157 866.458h78.769v-551.38h-78.769v551.38z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.258b09ca24134ae5fd5b43baa5288e06.svg";
export { ForwardRef as ReactComponent };